import { ClioService, UsersModel } from "../../../api";
import { CustomFieldOption } from "../../../api/models/CustomField";
import {
  CLIO_CUSTOM_FIELD_NAMES,
  ClioRoleField,
} from "./clioFieldNames";

export async function fetchClioCustomFieldOptions(
  field: ClioRoleField | string
): Promise<CustomFieldOption[]> {
  const fieldName =
    typeof field === "string" && field in CLIO_CUSTOM_FIELD_NAMES
      ? CLIO_CUSTOM_FIELD_NAMES[field as ClioRoleField]
      : field;

  try {
    const customFields = await ClioService.getApiClioCustomFields(fieldName);
    const options =
      customFields.find((c) => c.name === fieldName)?.picklist_options ?? [];
    return [...options].sort((a, b) => a.option.localeCompare(b.option));
  } catch (error) {
    console.error(`Failed to load options for ${fieldName}`, error);
    return [];
  }
}

export async function fetchClioCustomFieldOptionNames(
  field: ClioRoleField | string
): Promise<string[]> {
  const options = await fetchClioCustomFieldOptions(field);
  return options
    .map((o) => (o.option ?? "").trim())
    .filter(Boolean);
}

export async function fetchClioUsers(
  removeDisabled = false
): Promise<UsersModel[]> {
  try {
    return await ClioService.getApiClioClioUsers(removeDisabled);
  } catch (error) {
    console.error("Failed to load Clio users", error);
    return [];
  }
}

export async function fetchClioUserNames(
  removeDisabled = true
): Promise<string[]> {
  const users = await fetchClioUsers(removeDisabled);
  return users
    .map((u) => (u.name ?? "").trim())
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));
}
